<template>
  <div class="result">
    <div class="info-row">
      <b>团队名称：</b>
      <el-select
        v-model="teamId"
        size="medium"
        placeholder="请选择团队"
        @change="getList"
      >
        <el-option
          v-for="item in teamlist"
          :key="item.teamId"
          :label="item.name"
          :value="item.teamId"
        >
        </el-option>
      </el-select>
      <div class="captain">
        队长姓名：
        <span v-if="teamInfo">{{ teamInfo.captainName }}</span>
      </div>
    </div>

    <el-table :data="list" stripe class="list">
      <el-table-column prop="episode" label="集数" width="80" align="center">
      </el-table-column>
      <el-table-column prop="title" label="文案标题"> </el-table-column>
      <el-table-column label="后期视频" width="100" align="center">
        <template slot-scope="{ row }">
          <el-button
            size="mini"
            type="text"
            @click="
              showVideo = true;
              videoUrl = row.productionVideo;
            "
            >播放</el-button
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="上传时间"
        width="180"
        align="center"
      >
      </el-table-column>
      <!-- <el-table-column label="DOU+投放" align="center">
        <template slot-scope="{ row }">
          <p>投放目标: {{ row.target }}</p>
          <p>投放时间: {{ row.during }}</p>
          <p>投放方式: {{ row.mode }}</p>
          <p>投放金额: {{ row.amount }}</p>
        </template>
      </el-table-column> -->
      <el-table-column label="数据统计" align="center">
        <template slot-scope="{ row }">
          <p>点赞数: {{ row.diggCount }}</p>
          <p>下载数: {{ row.downloadCount }}</p>
          <p>播放数: {{ row.playCount }}</p>
          <p>分享数: {{ row.shareCount }}</p>
          <p>转发数: {{ row.forwardCount }}</p>
          <p>评论数: {{ row.commentCount }}</p>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      class="video-dialog"
      :visible.sync="showVideo"
      width="40%"
      :close-on-click-modal="false"
    >
      <video
        v-if="showVideo"
        style="width: 100%; max-height: 55vh"
        :src="videoUrl"
        controls
      ></video>
    </el-dialog>
  </div>
</template>

<script>
import { teamList } from "@/api/team";
import { resultList } from "@/api/projectPractice/accountOperation";

export default {
  data() {
    return {
      teamId: null,
      teamlist: [],
      list: [],
      showVideo: false,
      videoUrl: "",
    };
  },
  created() {
    this.getTeamList();
  },
  computed: {
    teamInfo() {
      return this.teamId
        ? this.teamlist.find((item) => item.teamId == this.teamId)
        : this.teamlist[0];
    },
  },
  methods: {
    // 团队列表
    getTeamList() {
      teamList({ classId: this.$route.query.id }).then((res) => {
        if (res.code == 0) {
          this.teamlist = res.data;
          if (this.teamlist) this.teamId = this.teamlist[0].teamId;

          this.getList();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 成果列表
    getList() {
      this.$loading.show();
      resultList({ teamId: this.teamId }).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.list = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.result {
  .info-row {
    margin-bottom: 10px;
    text-align: left;
    line-height: 36px;
    overflow: hidden;
    .captain {
      float: right;
      font-weight: bold;
      span {
        color: teal;
      }
    }
  }
  ::v-deep .list {
    .is-leaf {
      color: #333;
      background-color: #f5f5f5;
    }
  }
}
</style>